module.exports = __webpack_public_path__ + "img/login-magisteriodepichincha.1f33e847.svg";